/**
 * Blog CC — Minimal JS for search and category filter
 * Client-side search that filters visible article cards in the grid
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.querySelector('.blog-cc-categories__search-input');
    if (!searchInput) return;

    var gridSection = document.querySelector('.blog-cc-grid__list');
    if (!gridSection) return;

    var cards = gridSection.querySelectorAll('.blog-cc-card');
    var emptyMsg = document.querySelector('.blog-cc-grid__empty');
    var debounceTimer;

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        filterCards(searchInput.value.trim().toLowerCase());
      }, 250);
    });

    function filterCards(query) {
      if (!query) {
        cards.forEach(function(card) { card.hidden = false; });
        if (emptyMsg) emptyMsg.hidden = true;
        return;
      }

      var visibleCount = 0;
      cards.forEach(function(card) {
        var title = (card.querySelector('.blog-cc-card__title') || {}).textContent || '';
        var excerpt = (card.querySelector('.blog-cc-card__excerpt') || {}).textContent || '';
        var tag = (card.querySelector('.blog-cc-card__tag') || {}).textContent || '';
        var text = (title + ' ' + excerpt + ' ' + tag).toLowerCase();

        if (text.indexOf(query) !== -1) {
          card.hidden = false;
          visibleCount++;
        } else {
          card.hidden = true;
        }
      });

      if (emptyMsg) {
        emptyMsg.hidden = visibleCount > 0;
      }
    }
  });
})();
